module.exports = __webpack_public_path__ + "img/shield.67fcc430.svg";